import { Vue, Component, Prop } from 'vue-property-decorator'
import { VNode } from 'vue'
import { Column } from 'ant-design-vue/types/table/column'
import { FormFieldDto } from '@/service-proxies/app-v2/dnc.service-proxies'
import { widgetList } from '../utils/consts'

@Component
export default class FieldsTable extends Vue {
  @Prop()
  data: FormFieldDto[]

  @Prop()
  dataX: FormFieldDto[]

  @Prop()
  loading: boolean

  public pagination = {
    size:'big',
    pageSize: 30,
    total: 0,
    showQuickJumper: false,
    showSizeChanger: false,
    showTotal: total => (this.$t('Total…items') as string).replace('{0}', ` ${total} `)
  }

  get normData() {
    console.log(this.dataX)
    return this.dataX.map((item, index) => ({ index: index + 1, ...item }))
  }

  get normDataX() {
    let val = this.data.map((item, index) => ({ index: index + 1, ...item }))
    return val.length;
   }

  

  get columns() {
    return [
      {
        title: this.$t('page_resource_pool_action'),
        key: 'action',
        customRender: (_, record: FormFieldDto) => {
          if(record.code) {
          if (record.isSystem) {
            return (
              <a
                v-acl={'page_setting_resource_edit'}
                onClick={() => this.$emit('act', { type: 'edit', payload: record })}
              >
                {this.$t('edit')}
              </a>
            )
          } else {
            return (
              
              <div>
                <a
                  v-acl={'page_setting_resource_edit'}
                  onClick={() => this.$emit('act', { type: 'edit', payload: record })}
                >
                  {this.$t('edit')}
                </a>
                <a-divider v-acl={'page_setting_resource_delete'} type="vertical" />
                <a-popconfirm
                  title={this.$t('page_resource_pool_confirm_delete')}
                  onConfirm={() => this.$emit('act', { type: 'delete', payload: record })}
                  okText={this.$t('yes')}
                  cancelText={this.$t('no')}
                >
                  <a class="del-color" v-acl={'page_setting_resource_delete'}>{this.$t('delete')}</a>
                </a-popconfirm>
              </div>
            )
          }
          }
        },
        width: 100,
        // fixed: 'left',
      },
      {
        title: this.$t('page_resource_pool_no'),
        dataIndex: 'index',
        key: 'index',
        width: 120,
        customRender: (v,record) => {
          if(record.code) {
            return v ;
          }
        },
      },
      {
        title: this.$t('page_resource_pool_field'),
        dataIndex: 'code',
        key: 'code',
        width: 200
      },
      {
        title: this.$t('page_resource_pool_display_name'),
        dataIndex: 'title',
        key: 'title',
        width: 150
      },
      {
        title: this.$t('widget'),
        dataIndex: 'widget',
        key: 'widget',
        customRender: (v,record) => {
          if(record.code) {
            return widgetList(this).find(item => item.value === v)?.label
          }
        },
        width: 120
      },
      {
        title: this.$t('page_resource_pool_show'),
        dataIndex: 'isEnabled',
        key: 'isEnabled',
        customRender: (v,record) => {
          if(record.code) {
            return this.tagColumn(v) ;
          }
          
        },
        width: 100
      },
      {
        title: this.$t('page_resource_pool_required'),
        dataIndex: 'isRequired',
        key: 'isRequired',
        customRender: (v,record) => {
          if(record.code) {
            return this.tagColumn(v);
          }
        },
        width: 100
      },
      {
        title: this.$t('page_resource_pool_system_field'),
        dataIndex: 'isSystem',
        key: 'isSystem',
        customRender: (v,record) => {
          if(record.code) {
            return this.tagColumn(v);
          }
        },
      },
    ] as Column[]
  }

  tagColumn(v){
    return  v ? (
      <a-tag color="green">
        {this.$t('yes')}
      </a-tag>
    ) : (<a-tag color="red">
      {this.$t('no')}
    </a-tag>)
  }

  

  created() {
    this.pagination = {
      size:'big',
      pageSize: 30,
      showQuickJumper: false,
      showSizeChanger: false,
      total: this.data.length,
      showTotal: total => (this.$t('Total…items') as string).replace('{0}', ` ${total} `)
    }
  }

  watch: {

  }

  render(): VNode {

    this.pagination.total = this.data.length;


    return (
      <ml-table
        size="small"
        columns={this.columns}
        dataSource={this.normData}
        loading={this.loading}
        rowKey="code"
        pagination={this.pagination}
        scroll={{ x: false,y:570 }}
        canChangeColWidth={true}
      ></ml-table>
    )
  }
}
